module.exports = __webpack_public_path__ + "img/realestate-not-found.2ae729f6.svg";